import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  formContainer: {},
  viviendaInnerContainer: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '750px',
    },
  },
  innerContainer: {
    [theme.breakpoints.up('md')]: {
      margin: '0 auto',
      width: '95%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'center',
      borderRadius: '20px',
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    },
  },
  firtInputElement: {
    [theme.breakpoints.up('md')]: {
      flex: 1,
      margin: '40px 20px 40px 20px',
    },
  },
  inputPrecio: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
    },
  },
  engancheInput: {
    width: '100%',
  },
  secondInputElement: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'center',
    margin: '40px 0px 40px 0px',
    [theme.breakpoints.up('md')]: {
      margin: '40px 0px 40px 0px',
      flex: 2,
      alignItems: 'flex-end',
    },
  },
  precioContainer: {
    flex: 1,
    marginRight: '10px',
  },
  enganche: {
    textAlign: 'right',
    borderLeft: '1px solid #E9E9E9',
    paddingLeft: '5px',
  },
  invalidate: {
    color: 'red',
  },
  yearContainer: {
    flex: 1,
    [theme.breakpoints.up('md')]: {
      marginLeft: '10px',
      marginRight: '20px',
    },
  },
  thirdInputElement: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderTop: '3px solid #dedeeb',
    [theme.breakpoints.up('md')]: {
      borderTop: '0px',
      margin: '40px 0px 40px 0px',
    },
  },
  hidden: {
    display: 'none',
  },
  borderRight: {
    borderRight: '3px solid #dedeeb',
    [theme.breakpoints.up('md')]: {
      borderRight: '2px solid #dedeeb',
      borderLeft: '2px solid #dedeeb',
    },
  },
  element: {
    flex: 1,
    padding: '12px 0px 12px 0px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  },
  containerButton: {
    textAlign: 'center',
  },
  button: {
    marginTop: '70px',
    marginBottom: '50px',
    fontSize: '18px',
    fontFamily: 'Lato, sans-serif',
    fontWeight: '700',
    lineHeight: '18px',
    textAlign: 'center',
    color: '#000',
    backgroundColor: '#FFA500',
    padding: '20px 44px',
    textTransform: 'capitalize',
    borderRadius: '40px',
    '&:hover': {
      backgroundColor: '#FFA500',
      opacity: '0.6',
    },
    [theme.breakpoints.up('md')]: {
      backgroundColor: '#FFA500',
      marginTop: '70px',
      marginBottom: '70px',
    },
  },
}));
